"use strict";

import MultiItemInteractionView from "/js/interaction-views/multi-item-interaction-view.js";
import QuestionnaireItemView from "/js/interaction-views/questionnaire-item-view.js";

/**
 * Questionnaire interaction showing a series of views with question text and either a series of
 * buttons or one-or-two text inputs.
 */
export default class QuestionnaireInteractionView extends MultiItemInteractionView {

  initContent() {
    const numItems = this.data.questions.length;
    this.data.questions.forEach(function(questionObject, index) {

      const answerObject = (this.initialAnswers && this.initialAnswers.answers && this.initialAnswers.answers.length > index)
          ? this.initialAnswers.answers[index]
          : null;
      const item = new QuestionnaireItemView(questionObject, index, numItems, answerObject);
      this.$el.append(item.$el);
      this.items.push(item);
    }, this);
  }

  onAnswer(e, payload) {
    if (!this.answers) {
      this.answers = {
        interactionId: this.data.interactionId,
        type: "answers",
        answers: []
      };
    }
    this.answers.answers[payload.index] = payload.content;
    this.showNextItem();
  }
}
